module.exports = "/_next/static/images/01fd15a31059691e50a9dbe11410ee3a-xpeer-xs.jpg";